import type { Filter } from "pixi.js";
import { ColorMatrixFilter } from "pixi.js";
import { AdjustmentFilter, KawaseBlurFilter } from "pixi-filters";
import type { FilterKind } from "./FilterModal.types";

export const createPixiFilter = (
  kind: FilterKind,
  v: number,
  params?: Record<string, number>
): Filter | undefined => {
  try {
    switch (kind) {
      case "brightness":
        return new AdjustmentFilter({
          brightness: v,
          gamma: params?.gamma ?? 1,
          contrast: params?.contrast ?? 1,
          saturation: params?.saturation ?? 1,
          red: params?.red ?? 1,
          green: params?.green ?? 1,
          blue: params?.blue ?? 1,
        });
      case "blur":
        return new KawaseBlurFilter(Math.max(0, v), 3);
      case "grayscale": {
        const intensity = Math.min(1, Math.max(0, v));
        return new AdjustmentFilter({ saturation: 1 - intensity });
      }
      case "invert": {
        const f = new ColorMatrixFilter();
        f.negative(false);
        f.alpha = Math.min(1, Math.max(0, v));
        return f;
      }
      case "sepia": {
        const f = new ColorMatrixFilter();
        f.sepia(false);
        f.alpha = Math.min(1, Math.max(0, v));
        return f;
      }
      case "none":
      default:
        return undefined;
    }
  } catch {
    return undefined;
  }
};
